import { render, staticRenderFns } from "./Tiptap.vue?vue&type=template&id=bf8ea6be&"
import script from "./Tiptap.vue?vue&type=script&lang=js&"
export * from "./Tiptap.vue?vue&type=script&lang=js&"
import style0 from "./Tiptap.vue?vue&type=style&index=0&id=bf8ea6be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports